import { useState } from 'react'
import Container from 'react-bootstrap/Container'
import Carousel from 'react-bootstrap/Carousel'
import Image from 'react-bootstrap/Image'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import MainBanner from '../../../assets/images/home/banner.jpg'
import ControlLeftIcon from '../../../assets/icons/common/control-left-2.svg'
import ControlRightIcon from '../../../assets/icons/common/control-right-2.svg'
import { CLASSES } from '../../../assets/styles/styles'
import { IMAGE_URL } from '../../../utils/constants'
import { useNavigate } from 'react-router-dom'

function SliderBanner({ data = [] }) {
  const navigate = useNavigate()
  const [index, setIndex] = useState(0)

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex)
  }

  return (
    <div className='my-1'>
      <Carousel
        // activeIndex={index}
        hidden={false}
        indicators={document.body.clientWidth < 768}
        onSlide={handleSelect}
        onSelect={handleSelect}
        prevIcon={
          <div
            className='d-none d-md-block'
            style={{ width: '100%', minWidth: 100, borderRadius: '100%' }}
          >
            <Image
              style={{
                width: '25%',
                height: '25%',
                backgroundColor: 'green',
                borderRadius: '100%',
              }}
              src={ControlLeftIcon}
            />
          </div>
        }
        nextIcon={
          <div
            className='d-none d-md-block'
            style={{ width: '100%', minWidth: 100, borderRadius: '100%' }}
          >
            <Image
              style={{
                width: '25%',
                height: '25%',
                backgroundColor: 'green',
                borderRadius: '100%',
              }}
              src={ControlRightIcon}
            />
          </div>
        }
      >
        {data.map((banner, i) => (
          <Carousel.Item key={banner.id}>
            <div className='position-relative d-block d-sm-flex justify-content-center align-items-center'>
              <div
                style={{
                  // backgroundImage: `url(${
                  //   (banner.image_path?.startsWith('http') &&
                  //     banner.image_path) ||
                  //   (banner.image_path && IMAGE_URL + banner.image_path) ||
                  //   MainBanner
                  // })`,
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                  backgroundColor: 'rgba(14, 135, 66, 0.5)',
                  backgroundPosition: 'center',
                  width: document.body.clientWidth < 768 ? '100%' : '75%',
                  maxWidth: 1392,
                  aspectRatio: 16 / 9,
                  // objectFit: 'fill'
                }}
              >
                <Image
                  src={
                    (banner.image_path?.startsWith('http') &&
                      banner.image_path) ||
                    (banner.image_path && IMAGE_URL + banner.image_path) ||
                    MainBanner
                  }
                  className='h-100 w-100'
                />
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  )
}

export default SliderBanner
